<template>
  <div class="date-picker" :class="{ disabled }">
    <label>
      <slot name="label" />
      <VueDatePicker
        v-model="date"
        v-bind="$attrs"
        :disabled="disabled"
        auto-apply
        locale="ru"
        cancelText="Отмена"
        selectText="Выбрать"
        :class="{ 'only-past': onlyPast }"
      />
    </label>
    <div v-if="errorText" class="date-picker__error">
      <NotifyComponent
        v-for="(error, index) in errorText"
        :key="index"
        :text="error"
        status="error"
      >
        {{ error }}
      </NotifyComponent>
    </div>
  </div>
</template>

<script lang="ts" src="./DatePicker.ts"></script>

<style scoped lang="scss" src="./DatePicker.scss"></style>
